import {TimeLogger} from 'utils/logger';
import {normalizeError} from 'utils/normalize_error';

import {draftsLocalForage} from '../store';

export async function putDraft<P = any>(payload: P, id: string) {
    await draftsLocalForage.ready();
    if (payload == null) {
        await draftsLocalForage.removeItem(id);
    } else {
        try {
            await draftsLocalForage.setItem(id, payload);
        } catch (error: unknown) {
            TimeLogger.error({error: normalizeError(error), message: '[Dr] Send to statist failed'});
        }
    }

    return id;
}

export async function readDraft<P = any>(id: string) {
    await draftsLocalForage.ready();
    const item = await draftsLocalForage.getItem<P>(id);

    return item;
}
